import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    RBF0409E40: {}, //고객정보조회
    RBF0409E40_data: {}, //고객정보조회 (수정)
  };
};

const personalInfo = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default personalInfo;
